module.exports = __webpack_public_path__ + "static/media/linkedin-in.22bd1739.svg";